require('./iron/common/stylesheets/defaults/color-vars.styl');
require('./media/js/backbone.es5.js');
require('./media/js/backbone.mixins.es5.js');
require('./media/js/backbone.templateview.es5.js');
require('./media/js/backbone.widget.es5.js');
require('./media/js/backbone.viewrouter.es5.js');
require('./media/js/backbone.form.es5.js');
